
define('modules/application/wizard/classes/UIElement',[
  "app",

  // Libs
  "backbone"

],

function(app, Backbone) {
  // Create a new module
  var UIElement = app.module();

  // UIElement Model
  // ----------
  UIElement.Model = Backbone.Model.extend();

  // UIElement Views
  // ----------
  UIElement.Views = {
    titleBar  : Backbone.View.extend({
      keep : true,
      serialize: function() {
        return { model: this.model };
      },

      cleanup: function() {
        this.model.off(null, null, this);
      }
    }),
    content   : Backbone.View.extend({
      keep : true,
      serialize: function() {
        return { model: this.model };
      },

      cleanup: function() {
        this.model.off(null, null, this);
      }
    })
  };

  // Required, return the module for AMD compliance
  return UIElement;
});